<!--
 * @Author:
 * @Description: 数据查看
-->
<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <el-row class="flex">
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-input
        class="!w-200px mx-10px"
        size="small"
        v-model="searchData.dataSourceName"
        placeholder="数据源名称"
        clearable
      ></el-input>
      <el-input
        placeholder="测点编码"
        class="w-200px mr-10px"
        size="small"
        v-model="searchData.kks"
        clearable
      ></el-input>
      <el-input
        placeholder="测点描述"
        class="w-200px mr-10px"
        size="small"
        v-model="searchData.pointDescription"
        clearable
      ></el-input>
      <el-button type="primary" @click="searchList">搜索</el-button>
      <el-button @click="reset">重置</el-button>
    </el-row>
    <el-table
      class="mt-20px"
      height="calc(100% - 104px)"
      header-align="left"
      :data="tableData"
      v-loading="tableLoading"
      stripe
      border
    >
      <el-table-column type="index" width="50" :label="`${$t('serialNumber')}`">
        <template slot-scope="scope">
          <div>
            {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="dataSourceName" label="数据源" show-overflow-tooltip />
      <el-table-column prop="kks" label="测点编码" show-overflow-tooltip />
      <el-table-column prop="pointDescription" label="测点描述" show-overflow-tooltip />
      <el-table-column prop="value" label="实时值" show-overflow-tooltip />
      <el-table-column prop="realTime" label="时间" show-overflow-tooltip />
    </el-table>
    <div class="flex justify-end">
      <el-pagination
        class="my-20px"
        background
        @size-change="searchList"
        @current-change="getTableList"
        :current-page.sync="page.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :page-size.sync="page.pageSize"
        :total="page.total"
        :page-sizes="[15, 30, 50, 100]"
        :pager-count="5"
      >
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import configManagementService from '@/services/configManagementService'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'data-view',
  components: { selectStandardId },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      tableData: [],
      dataSourceDetail: {},
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      searchData: {
        dataSourceName: '',
        kks: '',
        pointDescription: '',
      },
    }
  },
  computed: {
    pointId() {
      return this.$route.params.id
    },
  },
  watch: {},
  created() {
    this.searchList()
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
      this.getTableList()
    },
    // 搜索
    searchList() {
      this.page.pageNo = 1
      this.getTableList()
    },
    // 重置
    reset() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    // 获取表格数据
    async getTableList() {
      const params = {
        standardId: this.standardId,
        isQueryIot: 1,
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        ...this.searchData,
      }
      if (this.pointId) {
        params.dataSourceConfigId = this.pointId
      } else {
        delete params.dataSourceConfigId
      }
      this.tableLoading = true
      const res = await configManagementService.getMeasuringpointList(params)
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>
